import React, { Component } from "react";
import { check } from "@xams-utils/check-types";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import withStyles from "@material-ui/core/styles/withStyles";

import { MFA_AUTHENTICATION_TYPES } from "constants/multi-factor-authentication";

const styles = ({ spacing }) => {
    return {
        providers: {
            marginBottom: spacing.unit * 2,
        },
    }}

const getMfaProviderLabel = (provider) => {
    let label = "";

    for (const [key, value] of Object.entries(MFA_AUTHENTICATION_TYPES)) {
        if (value === provider) {
            label = key;
        }
    }

    return label;
};

class MfaProviders extends Component {
    state = { tab: null };

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        const { provider, providers } = this.props;
        const tab = providers.findIndex((item) => item === provider);

        this.setState({ tab });
    }

    handleChange(_, tab) {
        const { onChange, providers } = this.props;

        this.setState({ tab }, () => {
            onChange(providers[tab]);
        });
    }
    
    render() {
        const {tab}=this.state;

        if (!check.assigned(tab)) {
            return null;
        }

        const {providers, classes}=this.props;

        return (
            <div className={classes.providers}>
                <Tabs
                    value={tab}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleChange}
                >
                    {providers.map((provider, index) => {
                        const label = getMfaProviderLabel(provider);
                        return (
                            <Tab
                                key={index}
                                label={label}
                            />
                        );
                    })}
                </Tabs>
            </div>
        );
    }
}

MfaProviders = withStyles(styles)(MfaProviders);

export { MfaProviders };
